export class MemoryBudgetManager {
  constructor(deviceMemory = 4) {
    this.deviceMemory = deviceMemory;
    this.meshBudget = deviceMemory <= 4 ? 900 : deviceMemory <= 8 ? 1800 : 3500;
  }

  assess(stats) {
    const ratio = (stats?.meshCount ?? 0) / this.meshBudget;
    return {
      budget: this.meshBudget,
      ratio,
      status: ratio > 1 ? 'over-budget' : ratio > 0.75 ? 'warning' : 'healthy'
    };
  }
}
